import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons.svg'


const _withScopeId = n => (_pushScopeId("data-v-794571fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = _imports_0 + '#icon-burger'
const _hoisted_2 = { class: "header d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "d-none d-md-flex justify-content-between align-items-center" }
const _hoisted_4 = { class: "header-list d-flex align-items-center mb-0" }
const _hoisted_5 = {
  href: "https://play.google.com/store/apps/details?id=com.withhalal.withhalalmobile",
  icon: "facebook",
  target: "_blank",
  title: ""
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", null, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": _hoisted_1 })
], -1))
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_logo = _resolveComponent("logo")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("header", _hoisted_2, [
    _createVNode(_component_logo),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
          return (_openBlock(), _createElementBlock("li", {
            key: link.name
          }, [
            _createVNode(_component_router_link, {
              to: link.link,
              class: "text-decoration-none"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(link.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ]),
      _createVNode(_component_Button, {
        name: "Sign Up for free",
        type: "blue",
        onClick: _ctx.launch
      }, null, 8, ["onClick"]),
      _createElementVNode("a", _hoisted_5, [
        _createVNode(_component_Button, {
          name: "Download App",
          type: "trans",
          class: "ms-5"
        })
      ])
    ]),
    _createElementVNode("button", {
      class: "header-burger d-md-none",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.nav && _ctx.nav(...args)))
    }, _hoisted_7)
  ]))
}